/**
 * Reiskosten calculator — calls gaan via WP AJAX (server-side Nominatim + OSRM).
 * Nonce uit data-attribuut voorkomt misbruik zonder IP-tracking.
 */

const COOLDOWN_S      = 2;
const MAX_PER_SESSION = 15;

function formatDuration(seconds) {
	const h = Math.floor(seconds / 3600);
	const m = Math.round((seconds % 3600) / 60);
	if (h === 0) return `${m} min`;
	return m === 0 ? `${h} uur` : `${h} uur ${m} min`;
}

function initReiskosten(section) {
	const btn      = section.querySelector('.sb-reiskosten__btn');
	const btnLabel = section.querySelector('.sb-reiskosten__btn-label');
	const input    = section.querySelector('.sb-reiskosten__vertrek');
	const result   = section.querySelector('.sb-reiskosten__result');
	const errorEl  = section.querySelector('.sb-reiskosten__error');
	const afstand  = section.querySelector('.sb-reiskosten__afstand');
	const tijd     = section.querySelector('.sb-reiskosten__tijd');
	const kosten   = section.querySelector('.sb-reiskosten__kosten');

	const modelId  = result?.dataset.modelId ?? '';
	const nonce    = result?.dataset.nonce ?? '';
	const ajaxUrl  = result?.dataset.ajaxUrl ?? '';
	const kmRate   = parseFloat(result?.dataset.kmTarief ?? '0.4269');

	if (!btn || !input || !result || !modelId || !nonce || !ajaxUrl) return;

	let lastCalc            = 0;
	let countTimer          = null;
	let sessionCount        = 0;
	let lastCalculatedAddr  = null;

	function setLoading(loading) {
		btn.disabled = loading;
		btn.classList.toggle('is-loading', loading);
		btnLabel.textContent = loading ? 'Berekenen…' : 'Bereken';
		if (loading) {
			result.hidden = false;
			result.classList.add('is-loading');
		} else {
			result.classList.remove('is-loading');
		}
	}

	function startCooldown() {
		let remaining = COOLDOWN_S;
		btn.disabled = true;
		countTimer = setInterval(() => {
			remaining--;
			btnLabel.textContent = `Wacht ${remaining}s…`;
			if (remaining <= 0) {
				clearInterval(countTimer);
				btnLabel.textContent = 'Bereken';
				btn.disabled = input.value.trim() === lastCalculatedAddr;
			}
		}, 1000);
	}

	async function calculate() {
		const vertrek = input.value.trim();
		if (!vertrek) { input.focus(); return; }

		if (sessionCount >= MAX_PER_SESSION) {
			errorEl.textContent = 'Je hebt het maximum aantal berekeningen voor deze sessie bereikt.';
			errorEl.hidden = false;
			return;
		}

		if (Date.now() - lastCalc < COOLDOWN_S * 1000) return;

		setLoading(true);
		errorEl.hidden = true;

		try {
			const body = new FormData();
			body.append('action', 'sb_reiskosten');
			body.append('nonce', nonce);
			body.append('from', vertrek);
			body.append('model_id', modelId);

			const resp = await fetch(ajaxUrl, { method: 'POST', body });
			const json = await resp.json();

			if (!json.success) {
				throw new Error(json.data?.message ?? 'Er is een fout opgetreden.');
			}

			const km = json.data.distanceM / 1000;
			afstand.textContent = `${km.toFixed(1)} km`;
			tijd.textContent    = formatDuration(json.data.durationS);
			kosten.textContent  = `€ ${(km * kmRate).toFixed(2)}`;

			lastCalc = Date.now();
			sessionCount++;
			lastCalculatedAddr = vertrek;
			setLoading(false);
			startCooldown();
		} catch (err) {
			errorEl.textContent = err.message ?? 'Er is een fout opgetreden.';
			errorEl.hidden = false;
			result.hidden = true;
			setLoading(false);
		}
	}

	input.addEventListener('input', () => {
		if (lastCalculatedAddr !== null) {
			btn.disabled = input.value.trim() === lastCalculatedAddr;
		}
	});

	btn.addEventListener('click', calculate);
	input.addEventListener('keydown', (e) => { if (e.key === 'Enter') calculate(); });
}

export function initAlleReiskosten() {
	document.querySelectorAll('.sb-reiskosten').forEach(initReiskosten);
}
